export default __webpack_public_path__ + "static/media/Paizo Logo.9e6adff6.jpg";